<template>
    <!-- 资金支付过程台账 -->
    <div class="contain wageLedger">
        <div class="header-box" style="color:#4C9AFF;font-size:20px;line-height: 40px;display: flex;align-items: center;">
            <el-page-header @back="goBack" content="资金支付过程台账"></el-page-header>
        </div>
        <div class="box" style="overflow: auto;">
            <div class="build-bar" style="justify-content: flex-end;">
                <!-- <span>选择月份：</span>
                <el-date-picker type="month" placeholder="选择日期" v-model="search.applyMonth" value-format="yyyy-MM" @change="doFilter"></el-date-picker>
                <p class="font-color2" style="padding:10px 20px;font-size:16px;margin:0;margin-left:30px;" >本次申报工资：{{num.money}}元</p>
                <p class="font-color2" style="padding:10px 20px;font-size:16px;margin:0;margin-left:30px;" >申报人数：{{num.person}}</p> -->
                <!-- <el-button type="success"  @click="exportOut" style="margin-right:10px;">导出模板</el-button> -->
                <!-- <div class="upload-demo" @click="exportOutDemo" style="cursor: pointer;">
                    <i class="el-icon-download" style="color:#36C635;font-size:28px;font-weight: bold;"></i>
                    <div class="el-upload__text">下载模板</div>
                </div> -->
                <div class="upload-demo" @click="exportOut" style="cursor: pointer;">
                    <i class="el-icon-download" style="color:#36C635;font-size:28px;font-weight: bold;"></i>
                    <div class="el-upload__text">下载</div>
                </div>
                <el-button size="small" icon="el-icon-plus" @click="addQin">添加</el-button>
                <!-- <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHead"
                    :data="uploadData"
                    :show-file-list="false" 
                    :on-success="handleAppSuccess">
                    <i class="el-icon-upload" style="color:#36C635;font-size:28px;font-weight: bold;"></i>
                    <div class="el-upload__text">上传</div>
                </el-upload> -->
            </div>
            <div class="box-content">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60" type="index">
                    </el-table-column>
                    <el-table-column label="合同编号">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.contractNumber"></el-input>
                            </span>
                            <span v-else>{{ scope.row.contractNumber }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同名称">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.contractName"></el-input>
                            </span>
                            <span v-else>{{scope.row.contractName}}</span>
                            <!-- <span>{{ scope.row.contractName }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="收款单位">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.receivingUnit"></el-input>
                            </span>
                            <span v-else>{{ scope.row.receivingUnit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="付款类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.paymentType"></el-input>
                            </span>
                            <span v-else>{{ scope.row.paymentType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.contractMoney"></el-input>
                            </span>
                            <span v-else>{{ scope.row.contractMoney }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="审计金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.auditMoney"></el-input>
                            </span>
                           <span v-else>{{ scope.row.auditMoney }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="本月完成工程量">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.monthComplete"></el-input>
                            </span>
                            <span v-else>{{ scope.row.monthComplete }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计完成工作量">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.cumulativeComplete"></el-input>
                            </span>
                            <span v-else>{{ scope.row.cumulativeComplete }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="已付金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.prepaidMoney"></el-input>
                            </span>
                            <span v-else>{{ scope.row.prepaidMoney }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="本次计划付款金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.planPrepaidMoney"></el-input>
                            </span>
                            <span v-else>{{ scope.row.planPrepaidMoney }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="付款比例（%）">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.bilv"></el-input>
                            </span>
                            <span v-else>{{ scope.row.bilv }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="来源">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isSet">
                                <el-input size="mini" placeholder="请输入内容" v-model="master.source"></el-input>
                            </span>
                            <span v-else>{{ scope.row.source }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="付款凭证">
                        <template slot-scope="scope">
                            <el-image  v-if="''!=scope.row.paymentVoucher" :src="scope.row.paymentVoucher" style="width:50px;height:50px" :preview-src-list="scope.row.paymentVouchers" ></el-image>
                            <el-upload
                                v-else
                                class="upload-demo"
                                :action="uploadUrl1"
                                :headers="uploadHead"
                                :data={type:214}
                                :objectBind='scope.row.id'
                                :show-file-list="false" 
                                :on-success="handleAppSuccess1">
                                <i class="el-icon-upload" style="color:#36C635;font-size:28px;font-weight: bold;"></i>
                                <div class="el-upload__text">上传</div>
                            </el-upload>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="el-tag el-tag--info el-tag--mini" style="cursor: pointer;margin-right: 10px;" @click="pwdChange(scope.row,scope.$index,true)">
                                {{scope.row.isSet?'保存':"修改"}}
                            </span>
                            <!-- <span v-if="!scope.row.isSet" class="el-tag el-tag--danger el-tag--mini" style="cursor: pointer;">
                                删除
                            </span> -->
                            <span v-if="scope.row.isSet" class="el-tag  el-tag--mini" style="cursor: pointer;" @click="pwdChange(scope.row,scope.$index,false)">
                                取消
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[3, 5, 10, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination> -->
            </div>
            <!-- <div class="box-content-item">
                <p class="cell">施工企业意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">施工企业盖章</p>
            </div>
            <div class="box-content-item">
                <p class="cell">监理公司现场监理部意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">监理公司盖章</p>
            </div>
            <div class="box-content-item">
                <p class="cell">建设管理中心意见：</p>
                <p class="cell">有权人签字：</p>
                <p class="cell">建设管理单位盖章</p>
            </div>
            <div class="box-content-item wrap" style="padding:50px;">
                <div class="row" style="text-align: right;">
                    <el-button type="primary" @click="subWage">确认提交</el-button>
                </div>
                <div class="row" style="text-align: left;">
                    <p class="warning">主要事项：</p>
                    <p class="warning">1、导出工资申报表  Excel格式，根据表格对应出勤天数进行填报工资，出勤天数与日工资和合计工资必须计算一致</p>
                    <p class="warning">2、导入工资表前必须选择导入一致的月份，姓名，排序，出勤天数要与导出表格数据一致方可导入成功</p>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            // search:{
            //     applyMonth:util.myTime.getCurMonth(),
            // },
            listData:[],
            groupId:"",
            // num:{
            //     money:0,
            //     person:0
            // },
            uploadUrl:myHttp.importExcelEPM,//上传地址
            uploadHead:{
                accessToken:this.$store.state.token
            },
            uploadData:{
                entProjectId:'',
                attachmentTypeId:'',
                userId:util.session.get('user').id
            },
            uploadUrl1:base.url+"/upload/uploadPhoto",//上传付款评依地址
            // currentPage: 1,
            // pageSize: 10,
            // totalItems: 0,
            dataText:'数据加载中...',
            entProjectId:'',
            attachmentTypeId:'',
            master:{
                id:'',
                contractNumber:'',
                contractName:'',
                receivingUnit:'',
                paymentType:'',
                contractMoney:'',
                auditMoney:'',
                monthComplete:'',
                cumulativeComplete:'',
                prepaidMoney:'',
                planPrepaidMoney:'',
                bilv:'',
                source:''
            },
            isAddFlag:false,
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.uploadData.entProjectId = this.$route.params.id
        this.uploadData.attachmentTypeId = this.$route.params.type
        this.entProjectId = this.$route.params.id
        this.attachmentTypeId = this.$route.params.type
        this.getData()
    },
    methods:{
        doFilter(){
            // this.uploadData.applyMonth = this.search.applyMonth
            this.getData()
        },
        //  handleSizeChange(val) {
        //     this.pageSize = val
        //     this.handleCurrentChange(this.currentPage)
        // },
        // handleCurrentChange(val) {
        //     this.currentPage = val
        //     this.currentChangePage();
        // },
        // // 监控当前页码
        // currentChangePage(list) {
        //     this.getData();
        // },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            //this.getData()
            // this.getAllNum()
        },
        //获取数据
        getData(){
            var that = this
            myHttp.getEntProjectMoney({
                entProjectId:this.entProjectId,
                attachmentTypeId:this.attachmentTypeId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.EntProjectMoney||[];
                    // var num = {money:0,person:list.length};
                    for(var i=0;i<list.length;i++){
                        list[i].bilv = list[i].planPrepaidMoney&&list[i].planPrepaidMoney!=0?(parseFloat(list[i].prepaidMoney)/parseFloat(list[i].planPrepaidMoney)*100).toFixed(2):0;
                        
                        list[i].paymentVoucher = list[i].paymentVoucher&&''!=list[i].paymentVoucher?base.httpCtx+list[i].paymentVoucher:''
                        if(''!=list[i].paymentVoucher){
                            list[i].paymentVouchers = []
                            list[i].paymentVouchers.push(list[i].paymentVoucher)
                        }
                        list[i].isSet = false
                    }
                    // num.money = num.money.toFixed(2);
                    that.listData = list;
                    // that.num = num;

                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                    // that.totalItems = resp.data.data.pageInfo.total||0;
                }else{
                    that.dataText = "暂无数据"
                }
            })
        },
        //获取项目数量
        getAllNum(){
            var that = this
            myHttp.getStatistical({
                groupId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.entity
                    if(that.search.unit==1){
                        var obj = data.jsdw[0]
                        obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
                        that.num = obj
                    }else if(that.search.unit==2){
                        var obj = data.sgdw[0]
                        obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
                        that.num = obj
                    }else{
                        var obj = data.jldw[0]
                        obj.buhege = parseInt(obj.zongshu) - parseInt(obj.hege)
                        that.num = obj
                    }
                }
            })
        },
        //导出模板
        exportOutDemo(){
            var token = this.$store.state.token;
            window.open(myHttp.downloadTempEPM+'?entProjectId='+this.entProjectId+'&accessToken='+token)
        },
        //导出
        exportOut(){
            var token = this.$store.state.token;
            window.open(myHttp.downloadEntProjectMoney+'?entProjectId='+this.entProjectId+'&attachmentTypeId='+this.attachmentTypeId+'&accessToken='+token)
        },
        //查看
        // handleEdit(index,row){
        //     this.$router.push('/checkDetail/'+row.id+'/'+row.type)
        // },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        //提交
        subWage(){
            // var that = this
            // var applyFormId = that.listData[0].applyFormId
            // myHttp.commitSalaryApply({
            //     applyMonth:this.search.applyMonth,
            //     projectId:this.groupId,
            //     applyFormId:applyFormId,
            //     userId:util.session.get('user').id
            // }).then(function(resp){
            //     if(resp.data.code=='200'){
            //         that.$router.go(-1);
            //         that.$message.success('提交成功');

            //     }else{
            //         that.$message.error(resp.data.msg);
            //     }
            // })
        },

        /**
         * 导入上传成功监听方法
         */
        handleAppSuccess(res,file){
            if(res.code=='200'){
                this.$message.success('上传成功');
                this.getData()
            }else{
                this.$message.error(res.msg);
            }
        },

        /**
         * 上传付款评依回调
         */
        handleAppSuccess1(res,file,opt,index){
            var id = index
            var that = this
            myHttp.updateEntProjectMoney({
                id:id,
                paymentVoucher:res.data.saveUrls
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('上传成功');
                    that.getData()
                }else{
                    that.$message.error(res.msg);
                }
            })
        },

        //添加
        addQin(){
            if(this.isAddFlag){
                this.$message.warning("请先保存当前台账");
                return
            }else if(this.master.id!=''){
                this.$message.warning("请先保存当前编辑项");
                return
            }
            this.isAddFlag = true
            this.master = {
                id:'',
                contractNumber:'',
                contractName:'',
                receivingUnit:'',
                paymentType:'',
                contractMoney:'',
                auditMoney:'',
                monthComplete:'',
                cumulativeComplete:'',
                prepaidMoney:'',
                planPrepaidMoney:'',
                paymentVoucher:'',
                bilv:0,
                entProjectId:this.entProjectId,
                attachmentTypeId:this.attachmentTypeId,
                userId:util.session.get('user').id,
                isSet:true
            }
            this.listData.push(this.master)
        },

        //修改
        pwdChange(row, index, cg) {
            //点击修改 判断是否已经保存所有操作
            var that = this
            //for (let i of this.master) {
            if (this.master.id!='' && this.master.id != row.id||(this.isAddFlag&&cg&&!row.isSet)) {
                this.$message.warning("请先保存当前编辑项");
                return false;
            }
            //}
            //是否是取消操作
            if (!cg) {
                //if (!app.master_user.sel.id) app.master_user.data.splice(index, 1);
                this.getData()
                this.master={
                    id:'',
                    contractNumber:'',
                    contractName:'',
                    receivingUnit:'',
                    paymentType:'',
                    contractMoney:'',
                    auditMoney:'',
                    monthComplete:'',
                    cumulativeComplete:'',
                    prepaidMoney:'',
                    planPrepaidMoney:'',
                    bilv:0,
                    source:'',
                }
                this.isAddFlag = false
                return row.isSet = !row.isSet;
            }
            //提交数据
            if (row.isSet) {
                //项目请求操作
                var that = this
                if(this.master.prepaidMoney!=''&&this.master.planPrepaidMoney!=''){
                    this.master.bilv = (parseFloat(this.master.prepaidMoney)/parseFloat(this.master.planPrepaidMoney)*100).toFixed(2)
                }
                if(this.master.id==''){
                    myHttp.postEntProjectMoney(this.master).then(function(resp){
                        if(resp.data.code=='200'){
                            that.isAddFlag = false
                            that.$message.success('添加成功');
                            that.getData()
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    })
                }else{
                    myHttp.updateEntProjectMoney(this.master).then(function(resp){
                        if(resp.data.code=='200'){
                            that.$message.success('保存成功');
                            that.getData()
                            that.master={
                                id:'',
                                contractNumber:'',
                                contractName:'',
                                receivingUnit:'',
                                paymentType:'',
                                contractMoney:'',
                                auditMoney:'',
                                monthComplete:'',
                                cumulativeComplete:'',
                                prepaidMoney:'',
                                planPrepaidMoney:'',
                                bilv:'',
                                source:'',
                            }
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    })
                }
            } else {
                this.master = {
                    id:row.id,
                    contractNumber:row.contractNumber,
                    contractName:row.contractName,
                    receivingUnit:row.receivingUnit,
                    paymentType:row.paymentType,
                    contractMoney:row.contractMoney,
                    auditMoney:row.auditMoney,
                    monthComplete:row.monthComplete,
                    cumulativeComplete:row.cumulativeComplete,
                    prepaidMoney:row.prepaidMoney,
                    planPrepaidMoney:row.planPrepaidMoney,
                    bilv:row.bilv,
                    source:row.source
                }
                row.isSet = true;
            }
        }
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 85px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content-item{
        width: 100%;
        background: #fff;
        min-height: 200px;
        margin-top: 6px;
        display: flex;
        align-content: center;
        align-items: center;
        box-sizing: border-box;
    }
    .box-content-item .cell{
        width: 33%;
        padding-left: 50px;
        text-align: left;
    }
    .box-content-item .row{
        width: 100%;
    }
    .box-content-item .row .warning{
        color: red;
    }
    .wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    /* 字体颜色 */
    .font-color1{
        color:#FFBC01;
    }
    .font-color2{
        color:#0085FF;
    }
    .upload-demo{
        margin: 0 20px;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    .el-pagination{
        background: #fff;
        padding: 15px 0;
    }
    .build-bar>.el-button--success{
        color: #FFF;
        background-color: #67C23A;
        border-color: #67C23A;
    }
    .el-image .el-icon-circle-close{
        color: #fff;
    }
    .wageLedger .el-button{
        color:#fff;
        background: #1890ff;
    }
</style>